import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const adopt = localStorage.getItem("evergrace_planner_id") || "";
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const { data } = await axios.post(`${API}/auth/session`, {}, {
          headers: { "X-Session-ID": sessionId, "X-Planner-Id": adopt },
          withCredentials: true,
        });
        setUser(data);
        window.history.replaceState({}, document.title, "/planner");
        navigate("/planner", { replace: true, state: { user: data } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory">
      <div className="flex items-center gap-3 text-sage">
        <Loader2 className="w-6 h-6 animate-spin" />
        <span className="font-serif text-xl text-navy">Signing you in…</span>
      </div>
    </div>
  );
}
